export const FORM_MODE = {
  new: 'NEW',
  edit: 'EDIT',
  view: 'VIEW',
  saleManagerEdit: 'SALE_MANAGER_EDIT',
};
